import CustomDatatableReports from 'libs/datatables/custom_datatable_reports'
export default function () {
  $(function() {
    new CustomDatatableReports($('table.report'))
  })
}
